module.exports = __webpack_public_path__ + "static/kid2-241e011e663fe250f71ee2b99aa0a172.jpg";